<div
  class="risk_range"
  [class]="(clazz ? clazz : '') + (size ? ' ' + size : '')"
>
  @for (index of _.range(7); track index) {
    <div
      [attr.index]="index + 1"
      [class.disabled]="disabled"
      [ngClass]="{
        active:
          (!Array.isArray(range) && range == index + 1) ||
          (range[0] <= index + 1 && range[1] >= index + 1),
      }"
    >
      {{ index + 1 }}
    </div>
  }
</div>
